import React, { Component } from 'react'
import { Spin } from 'antd'
import MyFrame from '../components/Frame'
import { Switch, Route, Redirect } from 'react-router-dom'
import ReInfo from "./review/ReInfo"
import { api, app } from "../app"
import '../css/review.css'
// import ReTrain from "./review/ReTrain"
// import ReTrainList from "./review/ReTrainList"
import ReTeam from "./review/ReTeam"
import RePush from "./review/RePush"
import ReHonorWall from "./review/ReHonorWall"
// import ReMessage from './review/ReMessage'
import ReInsure from './review/ReInsure'
import ReTask from "./review/ReTask";
import ReTeamApplicationAudit from './review/ReTeamApplicationAudit'
import ReTeamRegistrationInformationAudit from './review/ReTeamRegistrationInformationAudit'
// import LeavingMessage from './review/LeavingMessage'
import FList from "./find/FMList"

function checkMenu(path) {
    let key = null
    switch (path) {
        case '/review/info':
            key = '1'
            break
        case '/review/team':
            key = '2'
            break
        case '/review/trainList':
            key = '3'
            break
        case '/review/push':
            key = '4'
            break
        case '/review/honorWall':
            key = '5'
            break
        case '/review/note':
            key = '6'
            break
        case '/review/insure':
            key = '7'
            break
        case '/review/ReTeamApplicationAudit':
            key = '10'
            break
        case '/review/ReTeamRegistrationInformationAudit':
            key = '11'
            break
        case '/find':
            key = '14'
            break
        // case '/review/LeavingMessage':
        //     key = '13'
        //     break
    }
    // if (path.indexOf('/review/train') > -1) {
    //     key = '3'
    // }
    return key
}

class Review extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menu_key: null,
            audit: {},
            loading: true,
            auditTotal: 0
        }
        this.getTeamPrepAuditTeamAuthorizeAuditTotal()
    }

    setData = (data) => app.setStateSync(this, data)


    // 获取授权信息审核统计
    getTeamPrepAuditTeamAuthorizeAuditTotal = () => {
        app.post(api.TeamPrepAuditTeamAuthorizeAuditTotal, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                this.setState({
                    auditTotal: res.data.audit_count
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        })
    }

    /**
     * 获取审核统计
     * @returns {Promise<void>}
     */
    getAudit = async () => {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.AllAuditCount, params)
        let state = { loading: false }
        if (flag === 1) {
            // console.log(data)
            state.audit = data
        } else {
            app.alert(msg, "error")
        }
        this.setData(state)
    }

    async componentDidMount() {
        this._isMounted = true
        await this.getAudit()
        await this.setData({ menu_key: checkMenu(this.props.location.pathname) })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setData({ menu_key: checkMenu(nextProps.location.pathname) })
            this.getAudit()
        }
    }

    render() {
        const isLogin = app.checkLogin()
        if (isLogin) {
            return (<Redirect to="/" />)
        } else {
            const { menu_key, audit, loading } = this.state,
                menuList = [],
                nodeList = []
            //队员信息审核
            if (audit.user_Info_audit === true) {
                menuList.push({ key: '1', text: '队员信息审核', link: '/review/info', count: audit.user_Info_audit_count })
                nodeList.push(<Route key="1" exact path="/review/info" component={ReInfo} />)
            }
            //队伍信息审核
            if (audit.team_code_audit === true) {
                menuList.push({ key: '2', text: '队伍信息审核', link: '/review/team', count: audit.team_code_audit_count })
                nodeList.push(<Route key="2" exact path="/review/team" component={ReTeam} />)
            }

            if (audit.task_audit === true) {
                menuList.push({
                    key: "12",
                    text: "任务审核",
                    link: "/review/task",
                    count: audit.task_count,
                });
                nodeList.push(
                    <Route key="12" exact path="/review/task" component={ReTask} />
                );
            }

            //队员培训审核
            // if (audit.user_train_audit === true) {
            //     menuList.push({
            //         key: '3',
            //         text: '队员培训审核',
            //         link: '/review/trainList',
            //         count: audit.user_train_audit_count
            //     })
            //     nodeList.push(
            //         (<Route key="3" exact path="/review/trainList" component={ReTrain} />),
            //         // (<Route key="4" exact path="/review/train/:id" component={ReTrain}/>)
            //     )
            // }
            //发布信息审核
            if (audit.release_audit === true) {
                menuList.push({ key: '4', text: '发布信息审核', link: '/review/push', count: audit.release_audit_count })
                nodeList.push(<Route key="5" exact path="/review/push" component={RePush} />)
            }
            //荣誉墙审核
            if (audit.user_honor_audit === true) {
                menuList.push({ key: '5', text: '荣誉墙审核', link: '/review/honorWall', count: audit.user_honor_audit_count })
                nodeList.push(<Route key="7" exact path="/review/honorWall" component={ReHonorWall} />)
            }
            //短信审核
            // if (audit.note_audit === true) {
            //     menuList.push({ key: '6', text: '短信服务审核', link: '/review/note', count: audit.note_audit_count })
            //     nodeList.push(<Route key="8" exact path="/review/note" component={ReMessage} />)
            // }
            //保险审核
            if (audit.user_insurance_audit === true) {
                menuList.push({ key: '7', text: '保险审核', link: '/review/insure', count: audit.user_insurance_count })
                nodeList.push(<Route key="9" exact path="/review/insure" component={ReInsure} />)
            }

            //队伍申请审核
            if (audit.team_apply_audit === true) {
                menuList.push({ key: '10', text: '队伍申请审核', link: '/review/ReTeamApplicationAudit', count: audit.team_apply_count })
                nodeList.push(<Route key="11" path="/review/ReTeamApplicationAudit" component={ReTeamApplicationAudit} />)
            }

            //队伍注册信息审核
            if (audit.team_apply_auth_audit === true) {
                // console.log(this.state.auditTotal)
                if (this.state.auditTotal == 0) {
                    menuList.push({ key: '11', text: '队伍注册信息审核', link: '/review/ReTeamRegistrationInformationAudit', })
                    nodeList.push(<Route key="12" path="/review/ReTeamRegistrationInformationAudit" component={ReTeamRegistrationInformationAudit} />)

                } else {
                    menuList.push({ key: '11', text: '队伍注册信息审核', link: '/review/ReTeamRegistrationInformationAudit', count: this.state.auditTotal })
                    nodeList.push(<Route key="12" path="/review/ReTeamRegistrationInformationAudit" component={ReTeamRegistrationInformationAudit} />)

                }

            }

            //队伍注册信息审核
            // if (audit.team_apply_auth_audit === true) {
            //     // console.log(this.state.auditTotal)
            //     if (this.state.auditTotal == 0) {
            //         menuList.push({ key: '13', text: '留言审核', link: '/review/LeavingMessage', })
            //         nodeList.push(<Route key="13" path="/review/LeavingMessage" component={LeavingMessage} />)

            //     } else {
            //         menuList.push({ key: '13', text: '留言审核', link: '/review/LeavingMessage', count: this.state.auditTotal })
            //         nodeList.push(<Route key="13" path="/review/LeavingMessage" component={LeavingMessage} />)

            //     }

            // }

            // 寻人信息审核
            // menuList.push({ key: '14', text: '寻人启事审核', link: '/find' })
            // nodeList.push(<Route key="14" exact path="/review/team" component={FList} />)

            if (nodeList.length > 0) {
                nodeList.push(<Route key="6" render={() => <Redirect to={nodeList[0].props.path} />} />)
                return (
                    <MyFrame className="review" history={this.props.history} menuList={menuList}
                        menuSelectKey={menu_key}>
                        <Switch>
                            {nodeList}
                        </Switch>
                    </MyFrame>
                )
            } else if (loading) {
                return (
                    <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                        <Spin size="large" tip="正在加载..." />
                    </div>
                )
            } else {
                return (<Redirect to="/" />)
            }
        }
    }
}

export default Review



// WEBPACK FOOTER //
// ./src/routes/Review.jsx